import React from 'react';
import { createAndFireEvent, withAnalyticsContext, withAnalyticsEvents, } from '@atlaskit/analytics-next';
import Div from './styled';
import { name as packageName, version as packageVersion } from './version.json';
class Blanket extends React.Component {
    render() {
        const { canClickThrough, isTinted, onBlanketClicked } = this.props;
        const onClick = canClickThrough ? undefined : onBlanketClicked;
        const containerProps = { canClickThrough, isTinted, onClick };
        return React.createElement(Div, Object.assign({}, containerProps));
    }
}
Blanket.defaultProps = {
    canClickThrough: false,
    isTinted: false,
    onBlanketClicked: () => { },
};
export { Blanket as BlanketWithoutAnalytics };
const createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');
export default withAnalyticsContext({
    componentName: 'blanket',
    packageName,
    packageVersion,
})(withAnalyticsEvents({
    onBlanketClicked: createAndFireEventOnAtlaskit({
        action: 'clicked',
        actionSubject: 'blanket',
        attributes: {
            componentName: 'blanket',
            packageName,
            packageVersion,
        },
    }),
})(Blanket));
//# sourceMappingURL=Blanket.js.map